module.exports = __webpack_public_path__ + "img/putong@2x.57d87f42.png";